var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-delete" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-center flex-column align-items-center py-4"
      },
      [
        _c("img", {
          staticClass: "mb-3",
          attrs: {
            width: "84",
            height: "84",
            src: require("@/assets/illustration/trash-illustration.svg"),
            alt: "trash-illustration"
          }
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("p", { staticClass: "data-name" }, [
          _vm._v(" " + _vm._s(_vm.dataSelected.name) + " ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c(
              "b-button",
              {
                staticClass: "btn button-modal-delete m__r--5",
                on: {
                  click: function($event) {
                    _vm.$emit("close")
                  }
                }
              },
              [_vm._v("\n        Cancel\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn button-modal-delete red",
                on: {
                  click: function($event) {
                    _vm.$emit("delete")
                  }
                }
              },
              [_vm._v("\n        Yes\n      ")]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _vm._v("Are you sure to "),
      _c("span", [_vm._v("delete")]),
      _vm._v(" ?")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47396d80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47396d80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/jPopupDelete.vue
// module id = null
// module chunks = 